import { Injectable } from '@angular/core';
import { Usecase } from '../../../../domain/usecase/usecase.interface';
import { AuthRepository } from '../../../../domain/repositories/auth.repository';
import { RegisterUserDto } from '../../../../domain/dtos/auth.dto';

@Injectable({ providedIn: 'root' })
export class RegisterUsecase implements Usecase<RegisterUserDto, void> {
  constructor(private authRepository: AuthRepository) {}

  execute(userData: RegisterUserDto) {
    return this.authRepository.register(userData);
  }
}
